import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomerPartNumberModel } from "@tCooneyBrothers/ApiModels";
import { addCustomerPartNumber as addCustomerPartNumberApi } from "@tCooneyBrothers/Services/CustomerPartNumberService";
import { CustomApiHandler } from "@tCooneyBrothers/Store/CustomHandlerCreator";

type HandlerType = CustomApiHandler<CustomerPartNumberModel, CustomerPartNumberModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
    // eslint-disable-next-line no-console
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await addCustomerPartNumberApi(props.parameter);
    } catch (error) {
        if ("status" in error && error.status === 409) {
            props.dispatch({
                type: "Custom/Data/FailedCustomPopUp",
                openModal: true,
            });
        }
        return false;
    }
};

export const DispatchResetCustomerPartNumber: HandlerType = props => {
    props.dispatch({
        type: "Data/CustomerPartNumber/Reset",
    });
};

export const DispatchResetCustomerPartNumberWishLists: HandlerType = props => {
    props.dispatch({
        type: "Data/WishListLines/Reset",
    });
    props.dispatch({
        type: "Data/WishLists/Reset",
    });
};

export const DispatchResetCustomerPartNumberCart: HandlerType = props => {
    props.dispatch({
        type: "Data/Carts/Reset",
    });
};

// To do: we need to add first as BeginLoading then actual add cal as per below and then complete add
export const DispatchCustomerPartNumberAdd: HandlerType = props => {
    props.dispatch({
        type: "Data/CustomerPartNumber/Add",
        action: props.apiResult,
    });
};

// export const ExecuteOnSuccessCallback: HandlerType = props => {
//     props.parameter.onSuccess?.();
// };

export const chain = [
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchResetCustomerPartNumber,
    DispatchCustomerPartNumberAdd,
    DispatchResetCustomerPartNumberWishLists,
    DispatchResetCustomerPartNumberCart,
];

const addCustomerPartNumber = createHandlerChainRunner(chain, "AddCustomerPartNumber");
export default addCustomerPartNumber;
